import { Flex, Menu, MenuProps } from "antd";
import { FC, useMemo } from "react";
import { Link, useLocation } from "react-router";

import { Logo } from "@/components/Logo";

import BookIcon from "@/assets/book.svg?react";
import NewsIcon from "@/assets/news.svg?react";
import PieChartIcon from "@/assets/pie_chart.svg?react";
import { useTranslation } from "react-i18next";

export const Sider: FC = () => {
  const { pathname } = useLocation();
  const currLocation = pathname.split("/").pop();

  const { t } = useTranslation();

  const navigationItems: MenuProps["items"] = useMemo(
    () => [
      {
        key: "my-dashboard",
        icon: <PieChartIcon />,
        label: <Link to={"dashboard"}>{t("sidebar.dashboard")}</Link>,
      },
      {
        key: "my-learning",
        icon: <BookIcon />,
        label: <Link to={"my-learning"}>{t("sidebar.learning")}</Link>,
      },
      {
        key: "post-feed",
        icon: <NewsIcon />,
        label: <Link to={"post-feed"}>{t("sidebar.post")}</Link>,
      },
    ],
    [t]
  );

  return (
    <Flex rootClassName="sider-container" vertical align="center" gap={"60px"}>
      <Logo type="customer" className="sider-logo" style={{ width: 54, height: 90 }} />
      <Flex rootClassName="navigation-menu-container" vertical>
        <Menu rootClassName="navigation-menu" items={navigationItems} defaultSelectedKeys={currLocation ? [currLocation] : undefined} />
      </Flex>
    </Flex>
  );
};
